module.exports = __webpack_public_path__ + "img/logo.9b1e40cd.png";